<template>
	<div class="nav-line">
		<router-link class="nav-line__item" :to="{name: 'dice'}" :class="{active: page === 'dice'}">
			Dice
		</router-link>
		<router-link class="nav-line__item" :to="{name: 'mines'}" :class="{active: page === 'mines'}">
			Mines
		</router-link>
		<router-link class="nav-line__item" :to="{name: 'coinflip'}" :class="{active: page === 'coinflip'}">
			Coin
		</router-link>
		<router-link class="nav-line__item" :to="{name: 'slots'}" :class="{active: page === 'slots'}">
			Slots
		</router-link>
		<router-link class="nav-line__item" :to="{name: 'live'}" :class="{active: page === 'live'}">
			Live
		</router-link>
	</div>
</template>

<script>

export default {
	computed: {
		page() {
			return this.$route.name
		}
	},
}
</script>